import script from "./FormLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./FormLayout.vue?vue&type=script&setup=true&lang=js"

import "./FormLayout.vue?vue&type=style&index=0&id=79552c08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79552c08"]])

export default __exports__